<template>
    <div class="guest-list-overview">
        <div class="content">
            <div
                v-if="eventGuestList.guestList.length > 0"
                style="display: flex; margin-bottom: 3rem; flex-direction: row; justify-content: space-between"
            >
                <p>
                    {{ eventGuestList.guestList.length }} total guests,
                    <br />
                    {{
                        eventGuestList.guestList.length +
                        eventGuestList.guestList.map((guest) => guest.dates).reduce((prev, next) => prev + next)
                    }}
                    including dates
                    <br />(maximum
                    {{
                        eventGuestList.guestList.length +
                        eventGuestList.guestList.map((guest) => guest.maximumDates).reduce((prev, next) => prev + next)
                    }})
                </p>
                <p>
                    {{ eventGuestList.guestList.filter((guest) => guest.user && guest.user.gender === 'Male').length }}
                    male, <br />
                    {{
                        eventGuestList.guestList.filter((guest) => guest.user && guest.user.gender === 'Female').length
                    }}
                    female, <br />
                    {{
                        eventGuestList.guestList.filter((guest) => guest.user && guest.user.gender === 'Unspecified')
                            .length
                    }}
                    unspecified
                </p>
                <p>
                    {{ eventGuestList.guestList.filter((guest) => guest.status === 'Attending').length }}
                    Attending, <br />
                    {{ eventGuestList.guestList.filter((guest) => guest.status === 'Invited').length }}
                    Invited, <br />
                    {{ eventGuestList.guestList.filter((guest) => guest.status === 'Approved').length }}
                    Approved
                </p>
                <p>
                    {{ eventGuestList.guestList.map((guest) => !guest.email && !guest.phone).filter(Boolean).length }}
                    not invited yet, <br />
                    {{
                        Math.round(
                            (eventGuestList.guestList
                                .map((guest) => guest.email && guest.phone && guest.firstName && guest.lastName)
                                .filter(Boolean).length /
                                eventGuestList.guestList.length) *
                                100,
                        )
                    }}% complete data
                </p>
            </div>
            <div class="title-container">
                <h1>{{ $t('event.guest_list.title') }}</h1>
                <DInput v-model="search" :search="true" :placeholder="'Search'" aria-autocomplete="none"></DInput>
                <Select
                    v-model="status"
                    :placeholder="'Status'"
                    :options="[
                        {
                            value: undefined,
                            text: 'All Status',
                        },
                        {
                            value: 'Attending',
                            text: 'Attending',
                        },
                        {
                            value: 'Approved',
                            text: 'Approved',
                        },
                        {
                            value: 'Invited',
                            text: 'Invited',
                        },
                        {
                            value: 'Requested',
                            text: 'Requested',
                        },
                        {
                            value: 'HostDeclined',
                            text: 'Declined',
                        },
                    ]"
                />
                <!-- <Button
                    type="primary"
                    icon="plus"
                    :value="$t('event.guest_list.invite_guest')"
                    round
                    @click="openInviteGuestModal"
                /> -->
                <Button type="secondary" :value="'Import Guests'" round @click="openImportGuestModal" />
                <Button
                    type="primary"
                    icon="plus"
                    :value="$t('event.guest_list.insert_guest')"
                    round
                    @click="openInsertGuestModal"
                />
            </div>
            <div class="list guest-list">
                <GuestRow
                    v-for="guestRequest in eventGuestList.guestList"
                    :key="`${guestRequest.id}-${guestRequest.status}`"
                    @click="openInsertGuestModal"
                    :data="guestRequest"
                    @attend="attendGuest"
                    @approve="approveGuest"
                    @decline="declineGuest"
                    @attending="changeGuestStatus"
                    @approved="changeGuestStatus"
                    @requested="changeGuestStatus"
                    @declined="changeGuestStatus"
                    @invited="changeGuestStatus"
                />
            </div>
        </div>
        <Modal
            v-if="inviteGuestModal"
            class="import-venue-modal"
            @cancel="inviteGuestModal = false"
            @confirm="insertGuest"
        >
            <div class="modal-content">
                <div class="headline-container">
                    <div class="copy-l bold">{{ $t('event.guest_list.invite_guest') }}</div>
                </div>
                <div class="main">
                    <DInput v-model="email" :placeholder="'Email'" style="margin-bottom: 1.2rem"></DInput>
                    <DInput v-model="phone" :placeholder="'Phone'" style="margin-bottom: 1.2rem"></DInput>
                    <DInput v-model="phone" :placeholder="'Maximum Dates'" style="margin-bottom: 1.2rem"></DInput>
                    <!-- <Select
                        v-model="dates"
                        :placeholder="$t('event.guest_list.dates')"
                        :options="[
                            {
                                value: 1,
                                text: '1',
                            },
                            {
                                value: 2,
                                text: '2',
                            },
                            {
                                value: 3,
                                text: '3',
                            },
                            {
                                value: 4,
                                text: '4',
                            },
                            {
                                value: 99,
                                text: 'X',
                            },
                        ]"
                    /> -->
                </div>
                <div class="action-container fullwidth">
                    <Button type="secondary" :value="'Cancel'" @click="inviteGuestModal = false" />
                    <Button type="primary" :value="'Submit'" @click="inviteGuest" />
                </div>
            </div>
        </Modal>
        <Modal
            v-if="insertGuestModal"
            class="import-venue-modal"
            @cancel="insertGuestModal = false"
            @confirm="insertGuest"
        >
            <div class="modal-content">
                <div class="headline-container">
                    <div class="copy-l bold">{{ $t('event.guest_list.insert_guest') }}</div>
                </div>
                <div class="main">
                    <DInput
                        v-model="firstName"
                        :placeholder="'First Name (optional)'"
                        style="margin-bottom: 1.2rem"
                    ></DInput>
                    <DInput
                        v-model="lastName"
                        :placeholder="'Last Name (optional)'"
                        style="margin-bottom: 1.2rem"
                    ></DInput>
                    <DInput v-model="email" :placeholder="'Email'" style="margin-bottom: 1.2rem"></DInput>
                    <DInput v-model="phone" :placeholder="'Phone'" style="margin-bottom: 1.2rem"></DInput>
                    <DInput
                        v-model="dates"
                        :type="'number'"
                        :placeholder="'Maximum Dates'"
                        style="margin-bottom: 1.2rem"
                    ></DInput>
                </div>
                <div class="action-container fullwidth">
                    <Button type="secondary" :value="'Cancel'" @click="insertGuestModal = false" />
                    <Button
                        v-if="email !== '' || phone !== ''"
                        type="primary"
                        :value="'Send Invite'"
                        @click="inviteGuest"
                    />
                    <Button v-if="email === '' && phone === ''" type="primary" :value="'Submit'" @click="insertGuest" />
                </div>
            </div>
        </Modal>
        <Modal
            v-if="importGuestModal"
            class="import-venue-modal"
            @cancel="importGuestModal = false"
            @confirm="importGuests"
        >
            <div class="modal-content">
                <div class="headline-container">
                    <div class="copy-l bold">Select Excel File</div>
                </div>
                <div class="main">
                    <input
                        v-model="excelFile"
                        :type="'file'"
                        :placeholder="'First Name (optional)'"
                        style="margin-bottom: 1.2rem"
                        @change="processExcelFile"
                    />
                </div>
                <div class="action-container fullwidth">
                    <Button type="secondary" :value="'Cancel'" @click="importGuestModal = false" />
                    <Button type="primary" :value="'Import Guests'" @click="importGuests" />
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import GuestRow from '@/components/GuestRow'
import gql from 'graphql-tag'
import Select from '@/components/Select'
import Button from '@/components/Button'
import Modal from '@/components/Modal'
import DInput from '@/components/Input'
import readXlsxFile from 'read-excel-file'

export default {
    name: 'EventGuestList',
    components: {
        GuestRow,
        Button,
        Modal,
        DInput,
        Select,
    },
    data() {
        return {
            insertGuestModal: false,
            inviteGuestModal: false,
            importGuestModal: false,
            guestStatus: '',
            guest: undefined,
            search: '',
            firstName: '',
            lastName: '',
            email: '',
            phone: '+49',
            address: '',
            status: undefined,
            dates: undefined,
            excelFile: undefined,
            excelGuests: [],
            guestListId: undefined,
            errorMessage: false,
        }
    },
    apollo: {
        eventGuestList: {
            query: gql`
                query ($eventId: ID!, $status: GuestStatus, $search: String) {
                    eventGuestList(eventId: $eventId, status: $status, search: $search) {
                        guestList {
                            id
                            user {
                                id
                                instagram {
                                    igFullName
                                    igProfilePic
                                }
                                gender
                            }
                            firstName
                            lastName
                            status
                            dates
                            maximumDates
                            email
                            phone
                        }
                        guestListId
                    }
                }
            `,
            variables() {
                return {
                    eventId: this.$route.params.id,
                    search: this.search,
                    status: this.status,
                }
            },
        },
    },
    methods: {
        openInsertGuestModal() {
            this.insertGuestModal = true
        },
        openInviteGuestModal() {
            this.inviteGuestModal = true
        },
        openImportGuestModal() {
            this.importGuestModal = true
        },
        async approveGuest(data) {
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation ($guestID: ID!, $status: GuestStatus!) {
                            changeGuestStatus(guestID: $guestID, status: $status) {
                                status
                            }
                        }
                    `,
                    variables: {
                        guestID: data.id,
                        status: 'Approved',
                    },
                })
                .then(() => {
                    this.$router.go(this.$router.currentRoute)
                })
        },
        async declineGuest(data) {
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation ($guestID: ID!, $status: GuestStatus!) {
                            changeGuestStatus(guestID: $guestID, status: $status) {
                                status
                            }
                        }
                    `,
                    variables: {
                        guestID: data.id,
                        status: 'Requested',
                    },
                })
                .then(() => {
                    this.$router.go(this.$router.currentRoute)
                })
        },
        async attendGuest(data) {
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation ($guestID: ID!, $status: GuestStatus!) {
                            changeGuestStatus(guestID: $guestID, status: $status) {
                                status
                            }
                        }
                    `,
                    variables: {
                        guestID: data.id,
                        status: 'Attending',
                    },
                })
                .then(() => {
                    this.$router.go(this.$router.currentRoute)
                })
        },
        async changeGuestStatus(data, status) {
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation ($guestID: ID!, $status: GuestStatus!) {
                            changeGuestStatus(guestID: $guestID, status: $status) {
                                status
                            }
                        }
                    `,
                    variables: {
                        guestID: data.id,
                        status: status,
                    },
                })
                .then(() => {
                    this.$router.go(this.$router.currentRoute)
                })
        },
        async insertGuest() {
            if (this.firstName !== '') {
                await this.$apollo
                    .mutate({
                        mutation: gql`
                            mutation ($eventID: ID!, $status: GuestStatus!, $guestInput: GuestInput!) {
                                insertGuestList(eventID: $eventID, status: $status, guestInput: $guestInput) {
                                    status
                                }
                            }
                        `,
                        variables: {
                            eventID: this.$route.params.id,
                            status: 'Approved',
                            guestInput: {
                                firstName: this.firstName,
                                lastName: this.lastName,
                                phone: this.phone,
                                email: this.email,
                                address: this.address,
                                dates: parseInt(this.dates),
                            },
                        },
                    })
                    .then(() => {
                        this.$router.go(this.$router.currentRoute)
                    })
            } else {
                this.$pm.createToast('error', this.$t('errors.guest_required_name'))
            }
        },
        processExcelFile(event) {
            this.excelFile = event.target.files ? event.target.files[0] : null

            readXlsxFile(this.excelFile).then((rows) => {
                rows.map((row, index) => {
                    if (index === 0) {
                        // do nothing
                    } else {
                        const backendGuestTypes = ['aaa', 'vip', 'backstage']
                        const excelGuestTypes = row[5]
                            ? row[5]
                                  .split(',')
                                  .map((item) => item.trim().toLowerCase())
                                  .filter((value) => backendGuestTypes.includes(value))
                            : []

                        const formattedGuestTypes = excelGuestTypes.map((item) => {
                            if (item === 'aaa') return 'AAA'
                            if (item === 'backstage') return 'Backstage'
                            if (item === 'vip') return 'VIP'
                        })

                        let customPrice = String(row[6]).replace(/[^0-9.-]+/g, '')

                        this.excelGuests.push({
                            firstName: row[0],
                            lastName: row[1],
                            email: row[2],
                            phone: row[3],
                            dates: row[4],
                            type: parseInt(row[6]) > 0 ? 'PaidList' : 'GuestList',
                            guestType: formattedGuestTypes,
                            notes: row[7],
                            customPrice: parseInt(customPrice),
                        })
                    }
                })
            })
        },
        async importGuests() {
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation ($eventID: ID!, $input: [GuestInput!]!) {
                            inviteGuestListExcelImport(eventId: $eventID, input: $input)
                        }
                    `,
                    variables: {
                        eventID: this.$route.params.id,
                        input: this.excelGuests,
                    },
                })
                .then(() => {
                    this.$router.go(this.$router.currentRoute)
                })
                .catch((error) => {
                    console.log(error)
                    this.$pm.createToast('error', error)
                })
        },
        async inviteGuest() {
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation ($eventID: ID!, $input: GuestInput!, $guestListId: ID!) {
                            generateGuestListInvitation(eventId: $eventID, input: $input, guestListId: $guestListId) {
                                id
                            }
                        }
                    `,
                    variables: {
                        eventID: this.$route.params.id,
                        input: {
                            email: this.email,
                            phone: this.phone,
                            maximumDates: parseInt(this.dates),
                            firstName: this.firstName,
                            lastName: this.lastName,
                        },
                        guestListId: this.eventGuestList.guestListId,
                    },
                })
                .then(() => {
                    this.$router.go(this.$router.currentRoute)
                })
        },
    },
}
</script>

<style scoped lang="sass">
.title-container
    margin-bottom: $l
    @include breakpoint('m')
        display: flex
        flex-direction: column
</style>
